import React, { useEffect, useState } from "react";
import Section from "../../components/Section";
import { pageTitle } from "../../helpers/PageTitle";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import {
  LocalUser, // Plays the microphone audio track and the camera video track
  RemoteUser, // Plays the remote user audio and video tracks
  useIsConnected, // Returns whether the SDK is connected to Agora's server
  useJoin, // Automatically join and leave a channel on mount and unmount
  useLocalMicrophoneTrack, // Create a local microphone audio track
  useLocalCameraTrack, // Create a local camera video track
  usePublish, // Publish the local tracks
  useRemoteUsers, // Retrieve the list of remote users
} from "agora-rtc-react";
import AgoraRTC, { AgoraRTCProvider } from "agora-rtc-react";
import { useLocation, useNavigate } from "react-router-dom";
import { agoraAppId, imageBaseUrl } from "../../constants/ApiConstants";
import VideoCallComponent from "./VideoCallComponent";
import MyModal from "../../components/MyModal";

export default function VideoChat() {
  pageTitle("Video Chat");

  const location = useLocation();

  const client = AgoraRTC.createClient({ mode: "rtc", codec: "vp8" });

  const loggedInUserData = useSelector((state) => state.appSlice.userData);
  const loggedInUDoctorData = useSelector((state) => state.appSlice.doctorData);
  const loading = useState(false);
  const [leaveRequest, setLeaveRequested] = useState(true);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const leaveVideoCallRequest = async () => {
    sessionStorage.removeItem("videoCallData");
    window.close();
  };

  const [appointmentData, setAppointmentData] = useState(null);

  useEffect(() => {
    const rawData = sessionStorage.getItem("videoCallData");
    console.log(rawData);
    if (rawData) {
      try {
        const parsed = JSON.parse(rawData);
        setAppointmentData(parsed.appointmentData);
      } catch (e) {
        console.error("Invalid data");
      }
    }
  }, []);

  console.log("Appointment Data:", appointmentData);

  return (
    <Wrapper>
      {appointmentData && (
        <div>
          <AgoraRTCProvider client={client}>
            <VideoCallComponent appId={agoraAppId} appointmentData={appointmentData} channel={appointmentData.videoCall.channelId} token={appointmentData.videoCall.token} remoteUserCover={`${imageBaseUrl}${appointmentData.doctor.image}`} localUserCover={`${imageBaseUrl}${appointmentData.user.profile_image}`} onExitTap={leaveVideoCallRequest} />
          </AgoraRTCProvider>
        </div>
      )}
    </Wrapper>
  );
}
const Wrapper = styled.div``;
